import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { DailyEarning, CollectorSummary } from '../types';

export function useDailyEarnings(
  collectorId: string,
  from: string,
  to: string
) {
  return useQuery({
    queryKey: ['earnings-daily', collectorId, from, to],
    queryFn: async (): Promise<DailyEarning[]> =>
      pb.send(`/api/earnings/daily/${collectorId}?from=${from}&to=${to}`, {
        method: 'GET',
      }),
    enabled: !!collectorId && !!from && !!to,
    staleTime: 30_000,
  });
}

export function useCollectorSummary(collectorId: string | undefined) {
  return useQuery({
    queryKey: ['collector-summary', collectorId],
    queryFn: async (): Promise<CollectorSummary> =>
      pb.send(`/api/payments/collector/${collectorId}/summary`, {
        method: 'GET',
      }),
    enabled: !!collectorId,
    staleTime: 30_000,
  });
}
